//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.ShipDesign.FeatureParmsBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectPointList.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Boundary1",0,"SelectNXObjectList",0],[0,"Boundary1Plane",1,"Plane",0],[1,"Boundary2",0,"SelectNXObjectList",0],[0,"Boundary2Plane",1,"Plane",0],[0,"BoundaryOneModified",1,0],[0,"BoundaryReverse",1,0],[0,"BoundaryTwoModified",1,0],[1,"FirstIntersectionPoints",0,"SelectPointList",0],[0,"Limit1Method",1,0],[1,"Limit1Value",0,"Expression",0],[0,"Limit2Method",1,0],[1,"Limit2Value",0,"Expression",0],[0,"ReversePathDirection",1,0],[1,"SecondIntersectionPoints",0,"SelectPointList",0],[1,"SplitKnuckleLocations",0,"SelectPointList",0],[0,"UseNewDefaultSectionAlgorithm",1,0]],[[["points"],"SetBoundaryOnePoints",{},1,0],[["points"],"SetBoundaryTwoPoints",{},1,0],[["numCurves","curves"],"CreatePathCurves",{},0,0],[[],"DeletePathCurves",{},0,0],[["numCurves","curves"],"GetLastPathCurves",{},0,0],[[],"DeleteLastPathCurves",{},0,0],[["points"],"SetRegionPoints",{},1,0],[[],"CreatOrientationPathCurve",{},0,0],[["isChangeStart","isChangeEnd","isAllInBoudary"],"UpdateEndcutChangeStatus",{},3,0]],[]];
SPLM.Features.ShipDesign.ProfileSystemBuilder = class extends SPLM.Features.ShipDesign.FeatureParmsBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.ProfileSystemBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.ProfileSystemBuilder.LimitType = Object.freeze({
    "Value" : "Value", "Boundary" : "Boundary"});

SPLM.Features.ShipDesign.ProfileSystemBuilder.TrimOption = Object.freeze({
    "SquareCut" : "SquareCut", "NeatTrim" : "NeatTrim"});

export default SPLM;